'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * @fileOverview 组件参数格式化相关
 * @author kirkzheng
 */

/**
 * 将一定格式的props数据转化成defaultProps, propTypes
 * @param {Object} data 格式化的props数据
 * @returns {Object} {propTypes, defaultProps}
 * @example
 * data = {
 *      value: {
 *          type: PropTypes.oneOfType([
 *              PropTypes.string,
 *              PropTypes.number,
 *              PropTypes.bool
 *          ]).isRequired,
 *          defaultValue: ''
 *      }
 * };
 */
var formatProps = exports.formatProps = function formatProps() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var key = '',
        propTypes = {},
        defaultProps = {};

    for (key in data) {
        if (data[key]) {
            if (typeof data[key].type !== 'undefined') {
                propTypes[key] = data[key].type;
            }
            if (typeof data[key].defaultValue !== 'undefined') {
                defaultProps[key] = data[key].defaultValue;
            }
        }
    }

    return {
        propTypes: propTypes,
        defaultProps: defaultProps
    };
};

exports.default = formatProps;